import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from 'app/_globals';
import { SiteSummary } from 'app/_models/site-summary.model';
import { SiteService } from 'app/_services/site.service';
import { environment } from 'environments/environment';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'app-restrictions-report',
  templateUrl: './restrictions-report.component.html',
})
export class RestrictionsReportComponent implements OnInit {
  public routeRole;
  // date filters
  public toDate: Date;
  public fromDate: Date;

  // dropdown filters
  public sitesArray: any[] = [];
  public companiesArray: any[] = [];
  public workersArray: any[] = [];

  public selectedSite: any = { label: 'Select Site', value: undefined };
  public restrictionType:  any = { label: 'Asset & Site', value: undefined };
  public types = [
    { label: 'Asset & Site', value: undefined },
    { label: 'Asset', value: 'Asset' },
    { label: 'Site', value: 'Site' }
  ];

  // table data
  public restrictions: any[] = [];
  public pageSizes: any = environment.pageSizes;
  public pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Export Options
  private options = {
    title: '',
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true, // Excel-friendly UTF-8
    noDownload: false,
    headers: [
      'Restriction Id',
      'Category',
      'Restriction Type',
      'Description',
      'Site Name',
      'Asset Name',
      'Active',
      'Created By',
      'Created Date',
      'Last Modified By',
      'Last Modifed Date',
    ],
  };

  constructor(
    private sitesService: SiteService,
    private globals: Globals,
    private notificationService: NotificationService,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.toDate = new Date();
    const tempFromDate = new Date().setDate(this.toDate.getDate() - 30);
    this.fromDate = new Date(tempFromDate);

    this.resetPagination();
    this.getRestrictionsTableData();
    this.getSitesForDropdownFilter();
  }

  private getRestrictionsTableData() {
    const fromTimestamp = this.fromDate.getTime();
    const toTimestamp = this.toDate.getTime();
    this.sitesService.getRestrictionsReport( this.pagination, 'createdDate','asc', fromTimestamp, toTimestamp,
      this.selectedSite.value, this.restrictionType.value).subscribe((data: any) => {
        this.restrictions = data.body;
        this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public getSitesForDropdownFilter() {
    this.sitesService.getSiteListSummary().subscribe((data: SiteSummary[]) => {
      this.sitesArray.push(this.selectedSite);
      data.forEach((element: SiteSummary) => {
        const item = {
          label: element.siteName,
          value: element.siteId,
        };
        this.sitesArray.push(item);
      });
    });
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getRestrictionsTableData();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }

  // Handle Changes and relevant calls
  public onFromDateChange(event) {
    if (!event) { return; }

    this.fromDate = event;
    this.goToFirstPage();
    this.getRestrictionsTableData();
  }

  public onToDateChange(event) {
    if (!event) { return; }

    this.toDate = event;
    this.goToFirstPage();
    this.getRestrictionsTableData();
  }

  public onRestrictionTypeChange(event) {
    this.goToFirstPage();
    this.getRestrictionsTableData();
  }

  public onSelectedSiteChange(event) {
    this.selectedSite = event;
    this.goToFirstPage();
    this.getRestrictionsTableData();
  }


  public export() {
    const fromTimestamp = this.fromDate.getTime();
    const toTimestamp = this.toDate.getTime();
    this.sitesService
      .getRestrictionsReport({ size: 1000000, page: 0 }, 'createdDate', 'asc', fromTimestamp, toTimestamp, this.selectedSite.value, this.restrictionType.value)
      .subscribe((data) => {
          this.exportData(data.body);
        },
        (err) => {
          console.log(err);
          this.notificationService.notify('danger', `Error exporting Restrictions`);
        }
      );
  }

  private exportData(restrictionCSVRows: any[]) {
    const restrictionsToExport = [];

    restrictionCSVRows.forEach((element) => {

      const restrictionRow = {
        id: element.restrictionId,
        category: element.restrictionCategory,
        restrictionType:  getTypeLiteral(element),
        description: element.description,
        siteName: element.siteName,
        assetName: element.assetName,
        active: element.active,
        createdBy: element.createdBy,
        createdDate: new Date(element.createdDate).toLocaleDateString('en-GB'),
        lastModifiedBy: element.lastModifiedBy,
        lastModifiedDate: new Date(element.lastModifiedDate).toLocaleDateString('en-GB'),
      };
      restrictionsToExport.push(restrictionRow);
    });

    const fileName = 'Restrictions-Report-' + new Date(this.fromDate).toLocaleString() + 'to' + new Date(this.toDate).toLocaleString();
    new ngxCsv(restrictionsToExport, fileName, this.options);

    function getTypeLiteral(restriction: any): string {
      switch (restriction.restrictionType) {
        case 'HEALTH_AND_SAFETY':
          return 'Health & Safety';
        case 'OPERATIONAL':
          return 'Operational';
        default:
          return 'General';
      }
    }
  }
}
